<ion-app [ngClass]="getCustomCss()">
  <ion-router-outlet></ion-router-outlet>
  <a class="whatsappIcon" *ngIf="configService.company_info?.contact_number_enabled" target="_blank"
    href="https://api.whatsapp.com/send?phone={{configService.company_info?.contact_number}}&text=Hola,%20tengo%20una%20duda">
    <ion-icon src="assets/icon/whatsapp-icon.svg"></ion-icon>
  </a>
</ion-app>

<div class="central-loader" *ngIf="(authGuard.loader || authReverseGuard.loader || catalogueGuard.loader || shoppingCartGuard.loader || referralGuard.loader)">
  <div class="absolute-center">
    <img class="logo" *ngIf='configService.company_info?.logo' [src]="configService.company_info?.logo">
    <img class="spinner" src="assets/images/spinner.gif">
  </div>
</div>